module.exports = __webpack_public_path__ + "img/etiqueta_promo.dce943ac.svg";